export default "__VITE_ASSET__u2$jHuAI__"